import { EditConnectionAction } from '~src/datasource/dataConnection/actions/EditConnectionAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export const EditFlowAnalyticsExtensionConnection = 'EditFlowAnalyticsExtensionConnection';

export function editFlowAnalyticsExtensionConnection(dataConnectionsOrSources: IContentInfo[]): EditConnectionAction {
  return { type: EditFlowAnalyticsExtensionConnection, dataConnectionsOrSources };
}
